import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const ROLES = [
  { value: "admin", label: "Owner / Administrator" },
  { value: "manager", label: "Property Manager" },
  { value: "readonly", label: "Read-Only User" },
  { value: "contractor", label: "Maintenance Contractor" },
  { value: "pending", label: "Pending Approval", disabled: true },
];

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);

  const load = () => api.get("/users").then((r) => setUsers(r.data)).catch(() => toast.error("Failed to load users"));
  useEffect(() => { load(); }, []);

  const changeRole = async (u, role) => {
    try {
      await api.put(`/users/${u.user_id}/role`, { role });
      toast.success(`${u.email} is now ${role}`);
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="space-y-6" data-testid="page-users">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">User Management</h1>
        <p className="text-sm text-muted-foreground mt-1">Assign roles and permissions ({users.length} users)</p>
      </div>
      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              {["Name", "Email", "Current Role", "Set Role"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.user_id} className="border-b border-border last:border-0 hover:bg-muted/50" data-testid={`user-${u.user_id}`}>
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4 py-3">{u.email}</td>
                <td className="px-4 py-3 capitalize">{u.role}</td>
                <td className="px-4 py-3">
                  <Select value={u.role} onValueChange={(v) => changeRole(u, v)}>
                    <SelectTrigger className="rounded-xl w-52" data-testid={`role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{ROLES.map((r) => <SelectItem key={r.value} value={r.value} disabled={r.disabled}>{r.label}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
